import React from "react";

const EVENTS = [
  {
    id: "weddings",
    label: "For your special moments",
    title: "Weddings",
    description:
      "Elegant dessert pieces crafted to make your special day even sweeter. Custom buffets and refined presentations tailored just for you.",
    image: "/assets/wedding.jpg",
    imageAlt: "Wedding dessert table",
    imagePosition: "left",
    ctas: [
      { label: "Request a quote", href: "#contact", primary: true },
      { label: "Contact us", href: "#contact", primary: false },
    ],
  },
  {
    id: "birthdays",
    label: null,
    title: "Birthdays & celebrations",
    description:
      "Heart-shaped brownies, personalized gift boxes, and sweet messages. Everything you need to make every celebration unforgettable.",
    image: "/assets/brownies-small-hearts.jpeg",
    imageAlt: "Birthday brownies",
    imagePosition: "right",
    ctas: [
      { label: "Browse the ideas", href: "#products", primary: true },
    ],
  },
];

const EventCard = ({ event }) => {
  const imageBlock = (
    <div className="w-full md:w-1/2 aspect-[4/3] md:aspect-auto md:min-h-[380px] rounded-2xl overflow-hidden border border-dashed border-primary/30 bg-accent/20 flex items-center justify-center flex-shrink-0">
      <img
        src={event.image}
        alt={event.imageAlt}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={(e) => {
          e.target.style.display = "none";
          e.target.parentElement.querySelector(".img-fallback").style.display = "flex";
        }}
      />
      <span
        className="img-fallback hidden flex-col items-center gap-2 text-[#181411]/40 text-sm"
        aria-hidden="true"
      >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="m21 15-5-5L5 21" />
        </svg>
        {event.imageAlt}
      </span>
    </div>
  );

  const textBlock = (
    <div className="w-full md:w-1/2 flex flex-col justify-center gap-4 py-6 md:py-0">
      <h3 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-[#181411] leading-tight">
        {event.title}
      </h3>
      <p className="text-[#181411]/70 text-base sm:text-lg leading-relaxed max-w-sm">
        {event.description}
      </p>
      <div className="flex justify-center gap-3 mt-2">
        {event.ctas.map((cta) => (
          <a
            key={cta.label}
            href={cta.href}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${
              cta.primary
                ? "bg-[#181411] text-white hover:bg-[#181411]/80"
                : "border border-[#181411] text-[#181411] hover:bg-[#181411]/5"
            }`}
          >
            {cta.label}
          </a>
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center">
      {event.imagePosition === "left" ? (
        <>
          {imageBlock}
          {textBlock}
        </>
      ) : (
        <>
          {textBlock}
          {imageBlock}
        </>
      )}
    </div>
  );
};

const StorySlides = () => {
  return (
    <section
      id="our-story"
      className="w-full py-16 sm:py-24 bg-background-light dark:bg-background-dark/50"
    >
      <div className="px-4 md:px-10 lg:px-20 mx-auto max-w-6xl">
        {/* Section header */}
        <div className="mb-14 sm:mb-20">
          <p className="text-primary text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-3 flex items-center gap-2">
            <span className="inline-block w-8 h-px bg-primary" />
            For your special moments
          </p>
          <h2 className="text-[#181411] dark:text-white text-3xl sm:text-4xl md:text-5xl font-display font-bold leading-tight">
            Events &amp; weddings
          </h2>
        </div>

        {/* Event cards */}
        <div className="flex flex-col gap-16 sm:gap-24">
          {EVENTS.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StorySlides;
